import React from 'react';
import './sidebar.css'
import {FaLinkedin, FaFacebook, FaInstagram, FaGithub, FaEnvelope} from 'react-icons/fa'

export default function SideBar() {
    return(
        <div className="sidebar_body">
            <nav>
                <ul className="nav1">
                    <li><a href="https://www.facebook.com/Nakshatra.DU" target='_blank'>
                        {/* <i className="fab fa-facebook-f">
                            <span>Facebook</span>
                        </i> */}
                        <FaFacebook className="i" />
                    </a></li>

                    <li><a href="https://github.com/NakshatraNSUT" target='_blank'>
                        {/* <i className="fab fa-github"><span>Github</span></i> */}
                        <FaGithub className="i" />
                    </a></li>

                    <li><a href="https://www.instagram.com/nakshatra_nsut/" target='_blank'>
                        {/* <i className="fab fa-instagram"><span>Insatgram</span></i> */}
                        <FaInstagram className="i" />
                    </a></li>
                    <li><a href="https://www.linkedin.com/company/nakshatransit/" target='_blank'>
                        {/* <i className="fab fa-linkedin-in"><span>Linkedin</span></i> */}
                        <FaLinkedin className="i" />
                    </a></li>
                    <li><a href="mailto:nakshatransit@gmail.com">
                    {/* <i className="fa fa-envelope"><span>Mail</span></i> */}
                    <FaEnvelope className="i" />
                </a></li>
                    
                </ul>
            </nav>
        </div>
    )
}